import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TRAVEL_DOCUMENT_TYPE } from '@interfaces';
import moment from 'moment-timezone';

@Component({
  selector: 'app-partial-travel-document',
  templateUrl: './partial-travel-document.component.html',
  styleUrls: ['./partial-travel-document.component.scss'],
  standalone: false,
})
export class PartialTravelDocumentComponent implements OnInit {
  @Input() controls: { [key: string]: FormControl };
  public minValidDateInThePast: moment.Moment;
  public maxValidDateInThePast: moment.Moment;
  public minValidDateInTheFuture: moment.Moment;
  public maxValidDateInTheFuture: moment.Moment;
  public documentIssuePickerStartDate: moment.Moment;
  public documentExpiryPickerStartDate: moment.Moment;

  @Output() lastFieldTabPressed: EventEmitter<void> = new EventEmitter<void>();

  public primaryTravelDocumentType = TRAVEL_DOCUMENT_TYPE.ORDINARY_PASSPORT;
  public otherTravelDocumentTypes = this.getOtherTravelDocumentTypes();

  public ngOnInit(): void {
    this.minValidDateInThePast = moment().subtract(10, 'years');
    this.maxValidDateInThePast = moment();
    this.minValidDateInTheFuture = moment();
    this.maxValidDateInTheFuture = moment().add(10, 'years');
    this.documentIssuePickerStartDate = moment().subtract(2, 'years').startOf('year');
    this.documentExpiryPickerStartDate = moment().add(2, 'year').startOf('year');
    const travelDocumentType = this.controls.travelDocumentType;

    if (travelDocumentType.value) {
      return;
    }

    travelDocumentType.setValue(this.primaryTravelDocumentType, { emitEvent: false });
  }

  private getOtherTravelDocumentTypes(): TRAVEL_DOCUMENT_TYPE[] {
    const preferredPassportTypes = [
      TRAVEL_DOCUMENT_TYPE.TEMP_PASSPORT,
      TRAVEL_DOCUMENT_TYPE.DIPLOMATIC_PASSPORT,
      TRAVEL_DOCUMENT_TYPE.FOREIGNER_PASSPORT,
      TRAVEL_DOCUMENT_TYPE.GROUP_PASSPORT,
      TRAVEL_DOCUMENT_TYPE.OFFICIAL_PASSPORT,
      TRAVEL_DOCUMENT_TYPE.WORK_PASSPORT,
      TRAVEL_DOCUMENT_TYPE.SPECIAL_PASSPORT,
    ];

    const remainingTypes = Object.values(TRAVEL_DOCUMENT_TYPE).filter(
      type => type !== this.primaryTravelDocumentType && !preferredPassportTypes.includes(type)
    );

    return [...preferredPassportTypes, ...remainingTypes];
  }
}
